import Playlist from '../../models/playlist/playlist';

/** The raw string stored under `key`, or undefined when there is none. */
export function getLsItem(key: string): string | undefined {
  const value = localStorage.getItem(key);

  return value === null ? undefined : value;
}

/**
 * A playlist stored as JSON under `key`. Undefined when there is none, or
 * when what is there does not parse - that entry is removed so it cannot
 * fail the same way on every start.
 */
export function loadPlaylist(key: string): Playlist | undefined {
  const raw = getLsItem(key);

  if (raw === undefined) {
    return undefined;
  }

  try {
    return JSON.parse(raw) as Playlist;
  } catch {
    localStorage.removeItem(key);
    return undefined;
  }
}

export function setLsItem(key: string, value: unknown) {
  localStorage.setItem(key, JSON.stringify(value));
}
